module.exports = __webpack_public_path__ + "img/logo-maquillate-favicon_gif.06b31b6c.gif";